<script lang="ts">
import DoughnutChart from '../charts/DoughnutChart.svelte'

/**
 * Study chart card (`.cc`) wrapping `.ct` / `.cs` titles and a {@link DoughnutChart}.
 * Title/subtitle support `{@html}` for entities (`&middot;`, `&mdash;`) — trusted study copy only.
 */
interface Props {
  title: string
  subtitle?: string
  cardClass?: string
  cardStyle?: string
  labels: string[]
  data: number[]
  colors: string[]
  type?: 'doughnut' | 'pie'
  cutout?: string
  legendPosition?: 'right' | 'bottom' | 'left' | 'top'
  tooltipFormat?: (value: number, label: string, total: number) => string
  active?: boolean
  height?: string
}

let {
  title,
  subtitle,
  cardClass = '',
  cardStyle,
  labels,
  data,
  colors,
  type = 'doughnut',
  cutout = '60%',
  legendPosition = 'right',
  tooltipFormat,
  active = false,
  height = '190px',
}: Props = $props()
</script>

<div class="cc {cardClass}" style={cardStyle}>
  <div class="ct">{@html title}</div>
  {#if subtitle}
    <div class="cs">{@html subtitle}</div>
  {/if}
  <DoughnutChart
    {labels}
    {data}
    {colors}
    {type}
    {cutout}
    {legendPosition}
    {tooltipFormat}
    {active}
    {height}
  />
</div>
